import  React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { message } from 'antd';
import Script from 'react-load-script'

import './SweepLogin.styl'
import { sweepCodeInfo } from "@/api/login"

class SweepLogin extends Component{
  constructor(props) {
    super(props);
    this.handleSweepCode();
    this.state = {
      sweepCodeParams: {}
    }
  }

  render() {
    return (
      <div className="sweep-login">
        <div id="wx_reg" style={{minWidth: "198px"}}></div>
        <Script
          url="//rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js"
        />
      </div>
    )
  }

  /**
   * 获取扫码登录信息
   */
  async getSweepCodeInfo() {
    try {
      const res = await sweepCodeInfo();
      this.setState({
        sweepCodeParams: res || {}
      })
    } catch (error) {
      message.warning(error.message);
    }
  }
  // 展示登录二维码
  handleShowQRCode() {
    try {
      setTimeout( async() => {
        if (!window.WwLogin) {
          return
        }
        let redirectUri = process.env.REACT_APP_URL;
        if (redirectUri && redirectUri.startsWith('//')) {
          redirectUri = `${window.location.protocol}${redirectUri}`;
        }
        window.WwLogin({
          "id": "wx_reg",
          "appid": this.state.sweepCodeParams.corpId,
          "agentid": this.state.sweepCodeParams.agentId,
          "redirect_uri": redirectUri,
          "state": this.state.sweepCodeParams.state,
          "href": "https://static.ruigushop.com/rbox/launchpad/SweepLogin.css",
        });
      }, 200)
    } catch (error) {
      message.warning(error.message);
    }
  }
  async handleSweepCode() {
    await this.getSweepCodeInfo();
    await this.handleShowQRCode();
  }
}

export default withRouter(SweepLogin)
